import { useState, useCallback } from 'react';
import { PaginationState } from '../../invoiceUtils/invoiceTypes';

export interface UseInvoicesPaginationReturn extends PaginationState {
  handlePageChange: (newPage: number) => void;
  handlePageSizeChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  resetToFirstPage: () => void;
}

export const useInvoicesPagination = (
  initialPage: number = 1,
  initialPageSize: number = 25,
): UseInvoicesPaginationReturn => {
  const [currentPage, setCurrentPage] = useState(initialPage);
  const [pageSize, setPageSize] = useState(initialPageSize);

  const handlePageChange = useCallback((newPage: number) => {
    setCurrentPage(newPage);
  }, []);

  const handlePageSizeChange = useCallback(
    (event: React.ChangeEvent<HTMLSelectElement>) => {
      const newPageSize = parseInt(event.target.value, 10);
      setCurrentPage(1);
      setPageSize(newPageSize);
    },
    [],
  );

  const resetToFirstPage = useCallback(() => {
    setCurrentPage(1);
  }, []);

  return {
    currentPage,
    pageSize,
    handlePageChange,
    handlePageSizeChange,
    resetToFirstPage,
  };
};
